import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SystemService } from '../../service/system.service';
import { UserSearch } from '../../model/user.search';
import { SearchResult } from '../../model/search.result';
import { plainToClass } from 'class-transformer';
import { NavbarService } from '../../service/navbar.service';
import { SidebarService } from '../../service/sidebar.service';
import { FixedTopProgressBarComponent } from '../../component/fixed-top-progress-bar/fixed-top-progress-bar.component';
import { SelectionClipboardService } from '../../service/selection-clipboard.service';
import { NotificationService } from '../../service/notification.service';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit {
  results: SearchResult;
  selectedIndex: number;
  progressBar: FixedTopProgressBarComponent;

  TABS_INDEXES = {
    SUBMISSIONS: 0,
    REVIEWS: 1,
    COMMITTEES: 2,
    CHAIRS: 3,
    EVENTS: 4
  };

  // Seleção pra copy-to-clipboard — separada por tipo (submissões vs revisões).
  selectedSubmissionIds = new Set<number>();
  selectedReviewIds = new Set<number>();

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private systemService: SystemService,
    private navbarService: NavbarService,
    private sidebarService: SidebarService,
    private selectionClipboard: SelectionClipboardService,
    private notificationService: NotificationService,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  toggleSubmission(id: number, checked: boolean): void {
    if (checked) { this.selectedSubmissionIds.add(id); } else { this.selectedSubmissionIds.delete(id); }
  }
  toggleReview(id: number, checked: boolean): void {
    if (checked) { this.selectedReviewIds.add(id); } else { this.selectedReviewIds.delete(id); }
  }
  clearSelection(): void {
    this.selectedSubmissionIds.clear();
    this.selectedReviewIds.clear();
  }
  get selectionCount(): number {
    return this.selectedSubmissionIds.size + this.selectedReviewIds.size;
  }
  async copySelection(): Promise<void> {
    // Quando há seleção em AMBOS os tabs (submissões + revisões), o
    // copy gera os dois blocos no mesmo HTML.
    const subs = (this.results?.submissions || []).filter(s => this.selectedSubmissionIds.has(s.id));
    const revs = (this.results?.reviews || []).filter(r => this.selectedReviewIds.has(r.id));
    // Notificação removida pra evitar o "pulo" da página (MatSnackBar +
    // cdk-overlay-container oscila a scrollbar do window momentaneamente).
    await this.selectionClipboard.copyMixed(subs, revs);
  }

  ngOnInit() {
    this.selectedIndex = this.route.snapshot.queryParamMap['params'].where === 'all' ? 0 : -1;

    this.progressBar = this.navbarService.progressBar;

    this.sidebarService.close({});
    if (this.navbarService instanceof NavbarService) {
      const navbar = this.navbarService;
      navbar.changeBehavior({
        icon: 'fa-arrow-left',
        onClick: () => {
          this.router.navigateByUrl('/submissions');
          navbar.reset();
        }
      });
    }

    this.search();
  }

  search(): void {
    this.navbarService.loadingStart();

    this.route.queryParams.subscribe(params => {
      this.systemService.search( plainToClass(UserSearch, params as UserSearch) )
        .subscribe(res => {
          this.results = res;

          this.navbarService.loadingStop();
        });
    });
  }
}
